import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  PalantirButtonComponent,
  PalantirDialogComponent,
  PalantirDialogRef,
  PalantirIconComponent,
  PalantirTextComponent,
} from '@flux/design-system';
import { BlogFeedItem } from '../../../core/services/blog-notification/blog-notification.types';
import { DIALOG_DATA } from '@angular/cdk/dialog';

@Component({
  selector: 'app-blog-notification-dialog',
  templateUrl: './blog-notification-dialog.component.html',
  styleUrl: './blog-notification-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PalantirDialogComponent,
    PalantirTextComponent,
    PalantirButtonComponent,
    DatePipe,
    PalantirIconComponent,
  ],
})
export class BlogNotificationDialogComponent {
  private readonly dialogRef = inject(PalantirDialogRef);
  private readonly dialogData = inject<{
    posts: BlogFeedItem[];
  }>(DIALOG_DATA);

  public readonly displayPosts = signal(this.processPosts(this.dialogData.posts));

  private processPosts(posts: BlogFeedItem[]) {
    return posts.map((post) => {
      const parsedUrl = new URL(post.url);
      parsedUrl.hostname = window.location.hostname;
      parsedUrl.protocol = window.location.protocol;
      parsedUrl.port = window.location.port;
      return {
        id: post.id,
        title: post.title,
        content: post.summary,
        dateModified: post.date_modified,
        url: parsedUrl.toString(),
        showTitle: !/^<h[1-6]/i.test(post.summary),
        tags: post.tags.map((tag) => {
          const colorSuffix = this.hashColor(tag);
          return {
            name: tag,
            classes: `text-${colorSuffix}-500 bg-${colorSuffix}-500/10 border-${colorSuffix}-500`,
          };
        }),
      };
    });
  }

  private hashColor(tag: string) {
    const colors = [
      'blue',
      'green',
      'red',
      'yellow',
      'purple',
      'pink',
      'orange',
      'teal',
      'indigo',
      'cyan',
    ];
    const index = tag.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
    return colors[index];
  }

  public close(): void {
    void this.dialogRef.close();
  }
}
